<script>
import { Dashboard } from "@uppy/vue";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";

export default {
  name: "InlineFileUpload",
  props: ["allowMultipleUploads"],
  components: {
    Dashboard,
  },
  computed: {
    uppy() {
      const uppy = new Uppy({
        allowMultipleUploads: false,
        restrictions: {
          allowedFileTypes: ["image/*"],
        },
      });
      uppy.use(AwsS3, {
        companionUrl: "https://xali-uppy-companion.herokuapp.com/",
      });
      uppy.on("upload-success", (file, response) => {
        this.$emit("file-uploaded", response.uploadURL);
        uppy.reset();
      });
      return uppy;
    },
  },
  beforeDestroy() {
    this.uppy.close();
  },
};
</script>

<template>
  <dashboard :uppy="uppy" />
</template>
